import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Checkbox element, can be used seperately or integrated in accordion and listitems
 *
 * @prop {Boolean} checked - optional, controls the checked state of the checkbox
 * @prop {Boolean} disabled - optional, disabled the checkbox
 */
let SDBCheckbox = class SDBCheckbox extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.checked = false;
        this.label = '';
    }
    render() {
        return html `
            <sdb-content-icon
                id="checkbox"
                @click="${this._toggleChecked}"
                .icon="fal fa-square${this.checked ? '-check' : ''}"
            ></sdb-content-icon>
            ${this.label
            ? html `<label for="checkbox" @click="${this._toggleChecked}"
                      >${this.label}</label
                  >`
            : html ``}
        `;
    }
    _toggleChecked(e) {
        e.stopPropagation();
        this.checked = !this.checked;
        this.dispatchEvent(new CustomEvent('checked-changed', {
            detail: {
                value: this.checked,
            },
        }));
        this.requestUpdate();
    }
};
SDBCheckbox.styles = [
    elements,
    css `
            :host {
                display: flex;
                vertical-align: middle;
                cursor: pointer;
                width: auto;
                padding: 2.5px 0;
            }

            :host(:hover) > sdb-content-icon {
                --fa-icon-fill-color: var(--theme-primary);
            }

            :host > label {
                padding-left: 10px;
                cursor: pointer;
            }

            :host > sdb-content-icon {
                --fa-icon-fill-color: #b2b2b2;
            }

            :host([checked]) sdb-content-icon {
                --fa-icon-fill-color: var(--theme-primary);
            }

            :host([disabled]) {
                cursor: default;
                pointer-events: none;
            }

            :host([disabled]) sdb-content-icon {
                --fa-icon-fill-color: var(--element-lightgrey);
            }
        `,
];
__decorate([
    property({ type: Boolean, reflect: true })
], SDBCheckbox.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SDBCheckbox.prototype, "checked", void 0);
__decorate([
    property({ type: String })
], SDBCheckbox.prototype, "label", void 0);
SDBCheckbox = __decorate([
    customElement('sdb-content-checkbox')
], SDBCheckbox);
export { SDBCheckbox };
//# sourceMappingURL=sdb-content-checkbox.js.map